module.exports = {
  "country": "AU",
  "artist": "Voyager",
  "song": "Promise",
  "year": "2023",
  "place": "9",
  "spotify": "0LeK6Ol47og0WdGwKegNUL"
};